import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { HttpService } from "src/app/services/http.service";
import { UtilService } from "src/app/services/util.service";
import { FileInfo } from "src/app/models/docket";
import { HttpHeaders } from "@angular/common/http";
import { finalize, catchError, throwError } from "rxjs";
import { CaseDocketService } from "src/app/services/case-docket.service";

@Component({
    selector: 'app-replace-document',
    templateUrl: './replace-document.component.html',
    standalone: false
})

export class ReplaceDocumentComponent {
  isLoading = false;
  selectedDocument: FileInfo = {} as FileInfo;
  constructor(private caseDocketService: CaseDocketService, public dialogRef: MatDialogRef<ReplaceDocumentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private httpService: HttpService) { }

  onOk(): void {
    this.isLoading = true;
    const formData = { file_Id: this.selectedDocument?.file_Id, newValue: 'P' };
    this.caseDocketService.changeFileAttribute(formData, 'markAsPrimary').pipe(
      finalize(() => { this.isLoading = false }),
      catchError(err => {
        return throwError(err);
      })
    ).subscribe(() => {
        this.dialogRef.close('markAsPrimary');
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
